/**
 *              © 2025 Visa
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 **/
import{jsx as t}from"react/jsx-runtime";import a from"clsx";import{forwardRefTyped as e}from"../types/index.mjs";const s="v-tab",i=({className:e,sectionTitle:i,tag:r="li",...m},o)=>t(r,{className:a(s,i&&`${s}-section-title`,e),ref:o,...m});var r=e(i);i.defaultProps={tag:"li"},i.displayName="Tab";export{r as default};
